/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateActiveStateRequest } from '../../models/update-active-state-request';
import { User } from '../../models/user';

export interface UpdateUserActiveState$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: UpdateActiveStateRequest
}

export function updateUserActiveState(http: HttpClient, rootUrl: string, params: UpdateUserActiveState$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
  const rb = new RequestBuilder(rootUrl, updateUserActiveState.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<User>;
    })
  );
}

updateUserActiveState.PATH = '/api/v1/users/{id}/active_state';
